module.exports = __webpack_public_path__ + "img/icon-sumar.d81a4ca6.svg";